import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import NewsCategorySelector from "^/Components/ScrivitoExtensions/NewsCategorySelector";
import { LaIconEditorTab } from "^/Components/ScrivitoExtensions/LaIconEditorTab";
import HeadlineWidget from "../../Widgets/HeadlineWidget/HeadlineWidgetClass";
import SectionContentWidget from "../../Widgets/SectionContentWidget/SectionContentWidgetClass";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";
import {
  defaultPageInitialContent,
  defaultPageProperties,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("NewsOverviewPage", {
  title: "News Overview Page",
  hideInSelectionDialogs: true,
  attributes: localizeAttrList(
    [
      ...defaultPageProperties,
      ...metadataPropertiesGroup.properties,
      "navigationBackgroundImage",
      "isNavigationPage",
      "description",
    ],
    "NewsOverviewPage"
  ),
  properties: [...defaultPageProperties, "isNavigationPage"],
  propertiesGroups: [
    {
      title: "News overview",
      properties: [
        "headline",
        "subHeadline",
        "image",
        "description",
        "newsCountPerPage",
      ],
    },
    {
      title: "Category filter",
      key: "categories",
      component: ({ page }) => (
        <NewsCategorySelector
          content={page}
          lang={page.language()}
          currentValues={page.get("categoryFilter")}
          attributeName="categoryFilter"
        />
      ),
    },
    {
      title: "LA Icon",
      component: ({ obj }) => (
        <LaIconEditorTab obj={obj} attribute="navigationIcon" />
      ),
      key: "laIconEditorTab",
    },
    socialCardsPropertiesGroup,
    metadataPropertiesGroup,
  ],
  initialContent: {
    body: [
      new SectionContentWidget({
        content: [new HeadlineWidget({ style: "h1" })],
      }),
    ],
    ...metadataInitialContent,
    ...defaultPageInitialContent,
    title: "News Overview Page",
    isNavigationPage: "no",
    newsCountPerPage: 10,
  },
});
